import { ProductAttributeSortInput } from '~/modules/GraphQL/types';


const splitLastUnderscore = (inputString: string): [string, string] | null => {
  const lastIndex = inputString.lastIndexOf('_');
  if (lastIndex === -1) {
    return [inputString, ""];
  }
  const part1 = inputString.slice(0, lastIndex);
  const part2 = inputString.slice(lastIndex + 1);
  return [part1, part2];
}

export function createProductAttributeSortInput(sortData: string): ProductAttributeSortInput {

  const baseData = splitLastUnderscore(sortData);
  return baseData.length > 0 && baseData[0] != ''? Object.fromEntries([baseData]) : {};
}
